import { create } from "zustand";
import api from "@/lib/api";

export const usePlayerStore = create((set, get) => ({
  currentTrack: null,
  playlist: [],
  whatIsPlaying: null,
  lastSentTime: 0,
  subscriptionModalOpen: false,

  // وضعیت واقعی پخش که از رویدادهای play/pause خود APlayer پر می‌شود
  isPlaying: false,

  // شمارنده‌ای که هر بار افزایش می‌یابد تا Player توقف/ادامه را toggle کند
  toggleRequest: 0,

  stopPlaying: () =>
    set({
      playlist: [],
      currentTrack: null,
      whatIsPlaying: null,
      subscriptionModalOpen: false,
      isPlaying: false,
    }),
  setPlaylist: (tracks) => set({ playlist: tracks }),
  setCurrentTrack: (track) => set({ currentTrack: track }),
  setWhatIsPlaying: (track) => set({ whatIsPlaying: track }),
  setLastSentTime: (time) => set({ lastSentTime: time }),
  setIsPlaying: (value) => set({ isPlaying: value }),

  // صفحه با این اکشن توقف/ادامه‌ی همان داستانِ در حال پخش را درخواست می‌دهد
  requestTogglePlayback: () =>
    set((state) => ({ toggleRequest: state.toggleRequest + 1 })),

  openSubscriptionModal: () => set({ subscriptionModalOpen: true }),
  closeSubscriptionModal: () => set({ subscriptionModalOpen: false }),

  sendPlayProgress: (currentTime) => {
    const whatIsPlaying = get().whatIsPlaying;
    if (whatIsPlaying && currentTime - get().lastSentTime >= 10) {
      api(
        `/api/v1/story/${whatIsPlaying.id}/play/progress?session=${whatIsPlaying.session}&until=${currentTime}`,
        {
          method: "POST",
        }
      );
      set({ lastSentTime: currentTime });
    }
  },
}));
